import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthenticationService } from '../services/authentication.service';
import { AuthWebService } from 'app/services/authweb.service';
import { environment } from '../../environments/environment';
import { StorageService } from 'app/services/storage.service';


@Component({
    selector: 'home',
    templateUrl: 'home.component.html',
    styleUrls: ['home.component.css'],
    encapsulation: ViewEncapsulation.None,
  })

export class HomeComponent implements OnInit {
    title = 'Praxis iCBMS Base System';

    url: string ;
    pagehtml;

  constructor(private sanitizer: DomSanitizer, private authWebService: AuthWebService,
        private router: Router,private storageService:StorageService,
        private activRoute: ActivatedRoute) {}

    ngOnInit() {
      this.isUserLoggedIn();    
      this.setPageHTML()
    }

  isUserLoggedIn() {
    if (this.authWebService.authenticated === true) {
      if(this.storageService.isLogged){
        this.storageService.isLogged=false;
        (this.isExternal()) ? this.router.navigate(['carrier/accounts']) : this.router.navigate(['home']);
      }else{
        (this.isExternal()) ? this.router.navigate(['carrier/accounts/NEWAPP']) : this.router.navigate(['home']);
      }
      
    }
   }

  isExternal = () => {   
    return ((this.authWebService.userData.Roles.length == 1) && (this.authWebService.userData.Roles[0].Code == "GUEST")) ? true : false;
  }

  setPageHTML(){
    this.authWebService.webrequest("GET",'ConfigurationService', 'SystemConfig',JSON.stringify({
      systemCode: environment.authWebApi.systemCode
    })).then((data) => {
      environment.authWebApi.systemData = data;
      let html = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'iCBMS_Land1');
      if (html) {
        this.pagehtml = this.sanitizer.bypassSecurityTrustHtml(html.Value);
      } else {
        this.pagehtml = "CBRTA - Integrated Cross Border Management System";
      }

      //console.log( environment.authWebApi.userData )
    }, (error) => {
      //console.log(error)
    });
  }

}
